import React, { useState, useEffect } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { Button, Col, Image } from "react-bootstrap";
import { QRCode } from "react-qr-svg";
import QrReader from "react-qr-reader";
import SVG from "react-inlinesvg";
import isEmpty from "../../../../store/validation/is-Empty";
import { IconAndTitleLeftNav } from "../../navigationSection/UtilitiesLeftNav";
import { NavLink } from "react-router-dom";

export const Scan = (props) => {
  //state
  const [showTab, setShowTab] = useState(1);
  const handleChanheTab = (e) => {
    setShowTab(e);
  };
  const [onBoardingData, setOnBoardingDataId] = useState(
    {}
    // props.onboarding && props.onboarding._id
  );

  useEffect(() => {
    setOnBoardingDataId(props.sendData);
  }, []);

  const [state, setState] = useState({
    result: "No result",
  });
  const [scan, setScan] = useState(false);
  const handleScan = (data) => {
    if (data) {
      setState({
        result: data,
      });
      const temp_data = JSON.parse(data);
      if (
        (temp_data?.diner_id || temp_data?.order_id || temp_data?.event_id || temp_data?.expRequestId || temp_data?.exp_id) &&
        props.onSuccessScan &&
        !scan
      ) {
        setScan(true);
        props.onSuccessScan(temp_data);
        props.onCloseModal();
      }
      // console.log(data);
    } else {
      console.log("No data found..!");
    }
  };
  const handleError = (err) => {
    console.error(err);
  };

  const [pointOfContact, setPointOfContact] = useState();
  useEffect(() => {
    setPointOfContact(props.sendData && props.sendData.point_of_contact);
  }, []);
  let filtereddata = {};
  filtereddata =
    pointOfContact &&
    pointOfContact.filter((vendor) => vendor.defaultChecked === true);
  const onCloseModal = () => {
    setTimeout(() => props.onCloseModal(), 1000);
  };
  return (
    <React.Fragment>
      {/* <div
        className="filter-button-qrcode"
        style={{ backgroundColor: "#ee3a23",borderRadius:"6px" }}
      >
        <div
          className="filter-button-qrcode-box d-flex align-items-center justify-content-center"
          onClick={props.openModalScan}
        >
          <img
            src={require("../../../../assets/images/ActionImages/image/qrcode.svg")}
            className="img-fluid"
            alt="QR Scan"
            title="QR Scan"
            width="35px"
          />
        </div>
      </div> */}
      {props?.global ? (
        <>
          <li
            className={`position-relative ${
              // pathname && pathname === "/notification"
              //   ? "selected"
              //   :
              ""
            }`}
          >
            <NavLink
              exact
              to="#"
              title="Scan QR"
              className="dropdown-toggle btn btn-link"
            >
              <IconAndTitleLeftNav
                icon={require("../../../../assets/images/ActionImages/image/qrcode.svg")}
                title={props?.mobile ? null : <>Scan QR</>}
                mobile={props?.mobile}
              />
            </NavLink>
          </li>
        </>
      ) : (
        <div className="w-100">
          <Image
            src={require("../../../../assets/images/iconButton/scan_new.svg")}
            alt="Scan"
            title="Scan Icon"
            // onClick={this.onOpenModal}
            width="80"
          />
        </div>
      )}
      <Modal
        open={props.open}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customOverlay-request-accept-cancelled",
          modal: "scan-popup closeRemove p-0",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
      >
        <div className="d-flex border-bottom align-items-center py-3 px-4">
          <span className="pr-3 cursor" onClick={onCloseModal}>
            <Image
              alt="Back"
              width="20px"
              src={require("../../../../assets/images/UserManagement/backIcon.svg")}
            />
          </span>
          <div className="f12-400 c_black">Scan Now</div>
        </div>
        <div className=" px-3 pt-4 mb-3 border-bottom d-flex align-items-center">
          <Button
            variant="link"
            className={`px-0 mr-4 text-grayLink  ${
              showTab === 1 ? "active f12-700" : "f12-500"
            }`}
            onClick={() => handleChanheTab(1)}
          >
            Scan Any QR
          </Button>
          <Button
            variant="link"
            className={`px-0 mr-4 text-grayLink f12-500 ${
              showTab === 2 ? "active f12-700" : "f12-500"
            }`}
            onClick={() => handleChanheTab(2)}
          >
            Show Restaurant QR
          </Button>
        </div>
        {showTab === 1 && (
          <React.Fragment>
            <div className="position-relative">
              <div className="f24-700 text-white sn-po-center">
                Scan QR Code
              </div>
              <button type="button" className="flashLight">
                <SVG
                  alt="flash"
                  width="28px"
                  src={require("../../../../assets/images/UserManagement/flash.svg")}
                />
              </button>
              <QrReader
                className="qr-reader"
                delay={300}
                onError={(e) => handleError(e)}
                onScan={(e) => handleScan(e)}
                style={{ width: "100%", minHeight: "calc(100vh - 127px)" }}
              />
              <p>{state.result}</p>
              {/* <input
                type="text"
                className="qrField"
                placeholder="Type Mobile /Request No"
              /> */}
            </div>
          </React.Fragment>
        )}
        {showTab === 2 && (
          <React.Fragment>
            <div
              className="mx-0 d-flex align-items-end mb-3 w-100 border-0 sectionHeader"
              style={{ background: "#FFFBEE" }}
            >
              <Col>
                {!isEmpty(filtereddata) &&
                  filtereddata.map((singleitem, index) => {
                    return (
                      <React.Fragment key={index}>
                        <div className="f16-700">
                          {singleitem.firstName + " " + singleitem.lastName}
                        </div>
                      </React.Fragment>
                    );
                  })}
                <div className="f12-400 opacity5 pb-4">Name</div>
                {!isEmpty(filtereddata) &&
                  filtereddata.map((singleitem, index) => {
                    return (
                      <React.Fragment key={index}>
                        {!isEmpty(singleitem.phone_numbers) &&
                          singleitem.phone_numbers.map((phone, index) => {
                            return (
                              <React.Fragment key={index}>
                                <div className="f16-700">
                                  {phone.country_code + " " + phone.mobile_no}
                                </div>
                              </React.Fragment>
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
                <div className="f12-400 opacity5">Phone Number</div>
              </Col>
              <Col>
                {!isEmpty(filtereddata) &&
                  filtereddata.map((singleitem, index) => {
                    return (
                      <React.Fragment key={index}>
                        {!isEmpty(singleitem.enquiry_emails) &&
                          singleitem.enquiry_emails.map((email, index) => {
                            return (
                              <React.Fragment key={index}>
                                <div className="f16-700 text-lowercase">
                                  {email}
                                </div>
                              </React.Fragment>
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
                <div className="f12-400 opacity5">Email</div>
              </Col>
            </div>
            <div className="resQRCode" style={{ width: "35%", height: "35%" }}>
              <QRCode
                bgColor="#FFFFFF"
                fgColor="#000000"
                level="H"
                value={onBoardingData._id}
              />
            </div>
            <div className="py-4 text-center f24-700">
              {onBoardingData.restaurant_name}
            </div>
          </React.Fragment>
        )}
      </Modal>
    </React.Fragment>
  );
};
